import { useTextTranslation } from "../../utils/useTextTranslation";
import useMountedRef from "../../utils/useMountedRef";
import { flowCopy } from "../../utils/flowCopy";
import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import RtukAgeIcon from "../../assets/icons/svg/RtukAgeIcon";
import RtukGeneralIcon from "../../assets/icons/svg/RtukGeneralIcon";
import RtukSevenAgeIcon from "../../assets/icons/svg/RtukSevenAgeIcon";
import RtukThirteenAgeIcon from "../../assets/icons/svg/RtukThirteenAgeIcon";
import localizationStrings from "../../statics/localization";
import { getBroadcastCopy } from "../../statics/broadcastCopy";
import moment from "moment";
import defaultPoster from "../../assets/images/default-vod-horizontal-poster.png";
import { getProgramPosterUrl } from "../../utils/getProgramPosterUrl";
import SinglePlayIcon from "../../assets/icons/svg/SinglePlayIcon";
import ButtonPlayIcon from "../../assets/icons/svg/ButtonPlayIcon";
import ButtonRecordIcon from "../../assets/icons/svg/ButtonRecordIcon";
import {
  checkNpvrStatus,
  getUserSerieRecords,
  checkNpvrQuota,
  addRecord,
  removeRecord,
  getNpvrWatchUrl
} from "../../api/npvr/npvr";
import { getProgramPlayUrl } from "../../api/ltv/ltv";
import VideoPlayer from "../videoPlayer/VideoPlayer";
import Modal from "../modal/Modal";
import { getPrevueInfo, getChannel, checkPpvAuth } from "../../api/ltv/ltv";
import Notification from "../notification";
import UserRecordItem from "../userRecordItem";
import { getProgramAndNpvrThumbnail } from "../../api/common/commonApi";
import { pageChanged } from "../../utils/reporting/pageReporting";
import PpvPayment from "../ppvPayment/PpvPayment";
import formatProgramThumbnails from "../../utils/formatProgramThumbnails";
import { checkTvodSavetime } from "../../utils/checkTvodSaveTime";
import PopupCloseIcon from "../../assets/icons/svg/PopupCloseIcon";
import ToBeReacordIcon from "../../assets/icons/svg/ToBeReacordIcon";
import useOutsideClick from "../../utils/useOutsideClick";
import CastCarousel from "../castCarousel/CastCarousel";
import { getIsApiErrorPopupOpen, setWhereFrom } from "../../statics/config";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import { prettyTimeFormatter } from "../../utils/prettyTimeFormatter";
import ChannelControl from "../videoAlert/ChannelControl";
import getParentalAdvisoryElements from "../../utils/getParentalAdvisory";
import RecordOptionsPopup from "../videoPlayer/playerOptions/RecordOptionsPopup";

const playerOptions = {
  fill: true,
  fluid: true,
  responsive: true,
  preload: "auto",
  controls: true,
  liveui: false,
  autoplay: true,
  controlBar: {
    pictureInPictureToggle: false
  },
  html5: {
    nativeTextTracks: false,
    dash: {
      useTTML: true
    }
  }
};

const ProgramDetail = ({
  programData,
  seriesHeadId,
  epgProgramId,
  closeModal,
  recordItem,
  isRecord,
  fromLive,
  channels,
  fromVodGrid,
  fromTvGuide,
  setSelectedCutvProgram,
  selectedChannel,
  userFrameConfig,
  userInfo,
  location,
  hasHeight,
  isPlayer,
  history,
  directlyPlay,
  isCurrent,
  setRecordStatus,
  myTvChannelProgram,
  canPlay,
  setPlayUrl,
  playUrl,
  hasLoggedIn
}) => {
  const translateText = useTextTranslation();
  const mounted = useMountedRef();
  const recordPending = useRef(false);
  const [recordBusy, setRecordBusy] = useState(false);
  const [recordError, setRecordError] = useState(false);
  const [showPlayer, setShowPlayer] = useState(false);
  const [program, setProgram] = useState(null);
  const [episodes, setEpisodes] = useState([]);
  const [channel, setChannel] = useState(null);
  const [isRecordOptionsOpen, setIsRecordOptionsOpen] = useState(false); //new pop up design and logic
  const [showNotification, setShowNotification] = useState(false);
  const [npvrStatus, setNpvrStatus] = useState(null);
  const [deleteepgProgramId, setDeleteableepgProgramId] = useState(null);
  const [showRecordButton, setShowRecordButton] = useState(false);
  const programRef = useRef(null);
  const [posterSrc, setPosterSrc] = useState("");
  const [verticalPosterPath, setVerticalPosterPath] = useState("");
  const [disabled, setDisabled] = useState(false);
  const [thumbnails, setThumbnails] = useState([]);
  const [showLimitWarning, setShowLimitWarning] = useState(false);
  // const [showDeleteOptions, setShowDeleteOptions] = useState(false); //new pop up will handle this aswell
  const [canWatch, setCanWatch] = useState(true); //about parental settings
  const [ppvProduct, setPpvProduct] = useState(null);
  const [showPayment, setShowPayment] = useState(false);
  const [ppvCanWatch, setPpvCanWatch] = useState(false);
  const [mainProgramData, setMainProgramData] = useState(false);
  const [limitMessage, setLimitMessage] = useState(null);
  const [showDeleteText, setShowDeleteText] = useState(null);
  const [episodeRecord, setEpisodeRecord] = useState(null);
  const [posterHeight, setPosterHeight] = useState(null);
  const [showFullContent, setShowFullContent] = useState(false);
  const resolvedProgramId = programData?.epgProgramId || programData?.id;
  const hasProgramId =
    resolvedProgramId !== null &&
    resolvedProgramId !== undefined &&
    resolvedProgramId !== "" &&
    resolvedProgramId !== "null";
  const resolvedChannelUId =
    programData?.channelUId ||
    programData?.channelId ||
    selectedChannel?.id ||
    channel?.id ||
    null;
  const DESCRIPTION_LIMIT = 300; // we can change this to control max length
  const isDescriptionLong =
    programData?.description?.length > DESCRIPTION_LIMIT;
  const hasCasts = programData?.casts && programData?.casts.length > 0;

  const channelRef = useRef(null);
  const isSerieProgram = useRef(false);
  const modalRef = useRef(null);
  const isAnyPopupOpened = useRef(false);
  const posterWrapperRef = useRef(null);
  const deletePopupOpened = useRef(null);
  const playbackRequest = useRef(0);
  const [watchError, setWatchError] = useState(false);
  const [watchLoading, setWatchLoading] = useState(false);
  useEffect(
    () => () => {
      playbackRequest.current += 1;
    },
    []
  );

  const handleCloseRecordOptions = () => {
    setIsRecordOptionsOpen(false);
  };

  const normalizedNpvrStatus = String(npvrStatus ?? "").toLowerCase();
  const isAddRecordStatus =
    normalizedNpvrStatus === "-2" ||
    normalizedNpvrStatus === "not_found" ||
    normalizedNpvrStatus === "unknown" ||
    normalizedNpvrStatus === "not_recorded";
  const recordAllowed = programData?.isNpvrEnabled !== false &&
    programData?.isRecordable !== false && selectedChannel?.isNpvrEnabled !== false &&
    selectedChannel?.IsNpvrEnabled !== false;
  const isRecordingStatus =
    normalizedNpvrStatus === "recording" ||
    normalizedNpvrStatus === "0" ||
    normalizedNpvrStatus === "999";
  const isRecordedStatus =
    normalizedNpvrStatus === "recorded" || normalizedNpvrStatus === "1";

  useOutsideClick(modalRef, () => {
    if (
      !isAnyPopupOpened.current &&
      !getIsApiErrorPopupOpen() &&
      !deletePopupOpened.current
    )
      isRecord ? closeModal(null, true) : closeModal();
  });

  const checkWatchable = async () => {
    const request = playbackRequest.current;
    try {
      const data = await getProgramPlayUrl(programData?.epgProgramId);
      if (
        request === playbackRequest.current &&
        data.status === 200 &&
        data.data
      ) {
        setMainProgramData(true);
      }
    } catch (error) {
      /* Unavailable programmes remain without a watch action. */
    }
  };

  useEffect(() => {
    isRecord && getNpvrUrl(programData?.epgProgramId);
    programData && getNpvrStatus();
    if (!programData?.watchable && !isRecord) {
      checkWatchable();
    }
  }, []);

  const now = moment();
  const isCurrentlyPlaying =
    moment(programData?.startTime).isBefore(now) &&
    moment(programData?.endTime).isAfter(now);

  useEffect(() => {
    if (posterWrapperRef.current) {
      setPosterHeight(posterWrapperRef?.current?.offsetHeight);
    }
  }, [posterWrapperRef.current]);

  useEffect(() => {
    isAnyPopupOpened.current =
      showNotification || isRecordOptionsOpen || showPayment || showPlayer;
    // showDeleteOptions;
  }, [
    showNotification,
    isRecordOptionsOpen,
    showPayment,
    showPlayer
    // showDeleteOptions
  ]);

  const getProgram = async (code, episodeProgram = null) => {
    if (!code) {
      return;
    }
    const data = await getPrevueInfo(code);
    if (data.data.returncode === "0") {
      let programItem = data.data.data[0];

      programRef.current = programItem;
      if (!episodeProgram) {
        setProgram(programItem);
        let posterUrl = `${programItem?.posterpath}${
          programItem?.posterfilelist?.split(";")[2]
        }`;

        let posterUrl2 = `${programItem?.posterpath}${
          programItem?.posterfilelist?.split(";")[0]
        }`;
        if (
          programItem?.ratingid != " " &&
          (programItem?.ratingid & userInfo.userlevel) > 0
        ) {
          setCanWatch(false);
          setDisabled(true);
        } else {
          setCanWatch(true);
          setDisabled(false);
          setPosterSrc(posterUrl);
        }
        setVerticalPosterPath(posterUrl2);
        getChannelDetail(programItem?.channelcode);
      } else {
        setEpisodeRecord(episodeProgram);
        getChannelDetail(programItem?.channelcode, programItem);
      }
    }
  };

  const getUserSeriesNpvr = async (seriesHeadId) => {
    const { data } = await getUserSerieRecords(seriesHeadId);
    if (data.returncode === "0") {
      setEpisodes(data.data);
      if (directlyPlay) {
        // auto play if come with playButton
        getProgram(data?.data[0]?.epgProgramId, data?.data[0]);
      }
    } else {
      directlyPlay = false;
    }
  };

  const getNpvrStatus = async (code, seriesHeadId = null) => {
    if (!hasProgramId) {
      setNpvrStatus("-2");
      if (isPlayer) {
        setRecordStatus("-2");
      }
      return;
    }

    const data = await checkNpvrStatus(resolvedProgramId);
    if (data.status === 200) {
      const status = String(
        data?.data?.status ?? data?.data?.data?.status ?? ""
      );
      setNpvrStatus(status);
      if (isPlayer) {
        setRecordStatus(status);
      }
      if (
        status === "-2" &&
        programRef.current?.privaterecordenable === "1" &&
        programRef.current?.systemrecordenable === "1" &&
        checkTvodSavetime(
          programRef.current.begintime,
          channelRef.current.tvodsavetime
        )
      ) {
        setShowRecordButton(true);
      } else {
        setShowRecordButton(false);
      }
    } else {
      if (isPlayer) {
        setRecordStatus(null);
      }

      setShowRecordButton(false);
    }
  };

  const getChannelDetail = async (code, episodeProgram = null) => {
    const data = await getChannel(code);

    if (data.data.returncode === "0") {
      let channelData = data.data.data[0];
      channelRef.current = channelData;
      if (episodeProgram) {
        getNpvrUrl(episodeProgram, true);
      } else if (directlyPlay) {
        getNpvrUrl(programRef.current);
      } else {
        if (channelData?.auth_returncode === "0") {
          getNpvrStatus(epgProgramId, programRef.current?.seriesheadid);
        }
        if (programRef.current.isppv === "1") {
          let now =
            new Date().getTime() - parseInt(localStorage.getItem("timeDiff"));
          let arr = userFrameConfig.Purchase_PPV_LimitTime.split(",");
          let beforeLimitTime = parseInt(arr[0]) * 60 * 1000;
          let endLimitTime = arr[1] * 60 * 1000;

          if (
            (now >
              moment(
                programRef.current.begintime,
                "YYYY.MM.DD HH:mm"
              ).valueOf() -
                beforeLimitTime &&
              now <
                moment(
                  programRef.current.endtime,
                  "YYYY.MM.DD HH:mm"
                ).valueOf() -
                  endLimitTime) ||
            now >
              moment(programRef.current.endtime, "YYYY.MM.DD HH:mm").valueOf()
          ) {
            getPpvAuth(programRef.current.epgProgramId);
          }
        }
        if (fromLive) {
          selectedChannel?.islocked === "1"
            ? setDisabled(true)
            : setDisabled(false);
        } else {
          if (!isRecord) {
            let isLocked = channels?.find(
              (item) => item?.channelcode === channelData?.channelcode
            )?.islocked;
            isLocked === "1" ? setDisabled(true) : setDisabled(false);
          }
        }
      }

      setChannel(channelData);
    }
  };

  const checkProgramType = (isSerieRecord) => {
    if (isSerieRecord) {
      setIsRecordOptionsOpen(true);
    } else {
      checkRecordLimit();
    }
  };

  const checkRecordLimit = async (isSerieRecord = false) => {
    if (recordPending.current || !hasProgramId) return;
    recordPending.current = true;
    setRecordBusy(true);
    setRecordError(false);
    isSerieProgram.current = isSerieRecord;
    try {
      const response = await checkNpvrQuota();
      if (!mounted.current) return;
      if (response.status !== 200) throw new Error("Quota unavailable");
      const data = { ...response, ...response.data };
      if (String(data.islimitnpvr) === "1") {
        setLimitMessage(localizationStrings.formatString(localizationStrings.npvrHourLimitText, { hour: data.limitvalue }));
        setShowLimitWarning(true);
      } else if ((data.countLimitReached || (!data.isLimitless && (String(data.islimitnpvr) === "2" || data.quotaLeft === 0)))) {
        setLimitMessage(localizationStrings.npvrEpisodeLimitText);
        setShowLimitWarning(true);
      } else {
        await startRecord(isSerieRecord);
      }
    } catch (e) {
      if (mounted.current) setRecordError(localizationStrings.recordingErrors?.[
        String(e?.code ?? e?.response?.data?.ResultCode)
      ] || flowCopy().error);
    } finally {
      recordPending.current = false;
      if (mounted.current) setRecordBusy(false);
    }
  };

  const startRecord = async (isSerieRecord = false) => {
    if (!hasProgramId) {
      return;
    }

    const currentTime = new Date().getTime();

    let seriesId = isSerieRecord ? programData?.seriesId : null;
    let isRecordedNextEpisodes = isSerieRecord;

    let time = isRecordedNextEpisodes ? programData.startTime : currentTime;

    const data = await addRecord(
      resolvedProgramId,
      seriesId,
      time,
      isRecordedNextEpisodes,
      resolvedChannelUId
    );

    if (!mounted.current) return;
    if (data.status !== 200) throw new Error("Recording failed");
    if (data.status === 200) {
      getNpvrStatus();
    }
  };

  const deleteRecord = async (isDeletedAll = true) => {
    if (!hasProgramId) {
      return;
    }

    setShowNotification(false);

    const data = await removeRecord(
      resolvedProgramId,
      isDeletedAll,
      programData?.npvrRecordUId ||
        programData?.UId ||
        programData?.uId ||
        null,
      resolvedChannelUId
    );

    if (data.status === 200) {
      getNpvrStatus();
      if (isDeletedAll && isRecord) {
        closeModal(null, true);
      }
    }
  };

  const handleClickWatch = async () => {
    setWhereFrom("");
    if (isRecord) {
      setShowPlayer(true);
      setSelectedCutvProgram(programData);
      return;
    }
    const request = ++playbackRequest.current;
    setWatchError(false);
    setWatchLoading(true);
    try {
      const data = await getProgramPlayUrl(programData?.epgProgramId);
      if (request !== playbackRequest.current) return;
      let programUrl = data.data;
      if (data?.data) {
        if (fromLive) {
          setSelectedCutvProgram(programData);
          setPlayUrl(programUrl);
          window.scrollTo({ top: 0, behavior: "smooth" });
          closeModal();
          return;
        }
        setPlayUrl(programUrl);
        setShowPlayer(true);
        setSelectedCutvProgram(programData);
      } else {
        setWatchError(true);
      }
    } catch (error) {
      if (request === playbackRequest.current) setWatchError(true);
    } finally {
      if (request === playbackRequest.current) setWatchLoading(false);
    }

    //closeModal(true);

    window.scrollTo({ top: 0, behavior: "smooth" });
    /* if (data.data.returncode === "0") {
      setPlayUrl(data.data.httpsplayurl);
      getProgramThumbnail(
        moment(program.utcbegintime, "YYYY.MM.DD HH:mm").format(
          "YYYYMMDDHHmmss"
        ),
        moment(program.utcendtime, "YYYY.MM.DD HH:mm").format(
          "YYYYMMDDHHmmssss"
        )
      );
      setShowPlayer(true);
    } */
  };

  const getNpvrUrl = async (programId, isEpisode = false) => {
    setWhereFrom("");

    const data = await getNpvrWatchUrl(programId);

    if (data.status === 200) {
      let programUrl = data.data;
      if (programUrl) {
        setPlayUrl(programUrl);
      } else {
        setPlayUrl(null);
      }
      //setShowPlayer(true);
      /*  getProgramThumbnail(
        moment(program.utcbegintime, "YYYY.MM.DD HH:mm").format(
          "YYYYMMDDHHmmss"
        ),
        moment(program.utcendtime, "YYYY.MM.DD HH:mm").format("YYYYMMDDHHmmss")
      );
       */
    } else {
      setPlayUrl(null);
    }
  };

  const getProgramThumbnail = async (beginTime, endTime) => {
    const { data } = await getProgramAndNpvrThumbnail(
      userFrameConfig.cmsid,
      channelRef.current.cdnchannelcode,
      beginTime,
      endTime
    );
    if (data.returncode === "0") {
      let val = formatProgramThumbnails(data, beginTime, endTime);
      setThumbnails(val);
    } else {
      setThumbnails([]);
    }
  };

  const getPpvAuth = async (epgProgramId) => {
    const { data } = await checkPpvAuth(epgProgramId);
    if (data.returncode === "5") {
      let prod = data.productlist.find((item) => item.purchasetype == 3);
      setPpvProduct(prod);
    } else {
      if (data.returncode === "0") {
        setPpvCanWatch(true);
      }
      setPpvProduct(null);
    }
  };

  const renderedEpisodesItems = episodes.map((item, index) => {
    return (
      <UserRecordItem
        key={index}
        item={item}
        isEpisode={true}
        clickRecord={(record) => {
          getProgram(record?.epgProgramId, record);
        }}
        setPopupOpened={(val) => (deletePopupOpened.current = val)}
        setDeletedRecordCode={(code) => {
          getUserSeriesNpvr(seriesHeadId);
        }}
      />
    );
  });

  const renderButton = () => {
    if (!hasLoggedIn) {
      return (
        <div>
          <div
            className="program-detail-button"
            style={{
              cursor: "not-allowed"
            }}
          >
            <div className="icon">
              <ButtonRecordIcon />
            </div>
            <label
              style={{
                cursor: "not-allowed"
              }}
            >
              {localizationStrings.recordProgram}
            </label>
          </div>
        </div>
      );
    } else {
      return (
        <div style={{ display: "flex" }}>
          {fromTvGuide && isCurrent && (
            <button
              type="button"
              className="program-detail-live"
              onClick={() => closeModal(true)}
            >
              <ButtonPlayIcon />
              {getBroadcastCopy().watch}
            </button>
          )}
          {/* watch available */}
          {(programData?.watchable ||
            mainProgramData ||
            (isRecord && !!playUrl)) &&
            !programData.current &&
            !(fromTvGuide && isCurrent) && (
              <button
                type="button"
                onClick={handleClickWatch}
                disabled={watchLoading}
                aria-label={localizationStrings.watch}
                className="program-detail-button play"
                style={{ marginRight: "1vw" }}
              >
                <div className="icon">
                  <ButtonPlayIcon />
                </div>
                {/* <label>{localizationStrings.watch}</label> */}
              </button>
            )}
          {/* record available */}
          {isAddRecordStatus && recordAllowed && (
            <button type="button"
              className="program-detail-button record-button"
              aria-label={localizationStrings.recordProgram}
              disabled={disabled || !canWatch || recordBusy} aria-busy={recordBusy}
              onClick={() => checkProgramType(programData?.seriesId)}>
              <span className="icon"><ButtonRecordIcon /></span>
            </button>
          )}

          {/*  to be record */}
          {isRecordingStatus && (
            <div
              onClick={() => {
                if (!!programData?.seriesId) {
                  setIsRecordOptionsOpen(true);
                } else {
                  setShowNotification(true);
                  isAnyPopupOpened.current = true;
                }
              }}
            >
              <div
                className={`program-detail-button record-button ${
                  !showDeleteText ? "orange" : ""
                }`}
                onMouseEnter={() => setShowDeleteText(true)}
                onMouseLeave={() => setShowDeleteText(false)}
              >
                <div className="icon">
                  <ToBeReacordIcon />
                </div>
                {/* <label>
                  {showDeleteText
                    ? localizationStrings.deleteRecord
                    : localizationStrings.toBeRecord}
                </label> */}
              </div>
            </div>
          )}
          {/* recorded */}
          {isRecordedStatus && (
            <div
              onClick={() => {
                if (!!programData?.seriesId) {
                  setIsRecordOptionsOpen(true);
                } else {
                  setShowNotification(true);
                }
              }}
            >
              <div
                className={`program-detail-button record-button ${
                  !showDeleteText ? "orange" : ""
                }`}
                onMouseEnter={() => setShowDeleteText(true)}
                onMouseLeave={() => setShowDeleteText(false)}
              >
                <div className="icon">
                  <ToBeReacordIcon />
                </div>
                {/* <label>
                  {showDeleteText
                    ? localizationStrings.deleteRecord
                    : localizationStrings.recorded}
                </label> */}
              </div>
            </div>
          )}
        </div>
      );
    }
  };

  useEffect(() => {
    if (myTvChannelProgram) {
      myTvChannelProgram.prevuename = myTvChannelProgram.programname;
      myTvChannelProgram.begintime = myTvChannelProgram.starttime;
      setProgram(myTvChannelProgram);
      let posterUrl = `${myTvChannelProgram?.posterpath}${
        myTvChannelProgram?.posterfilelist?.split(";")[6]
      }`;

      setPosterSrc(posterUrl);
    } else if (
      isRecord &&
      seriesHeadId !== "0" &&
      !!seriesHeadId &&
      userFrameConfig
    ) {
      setProgram(recordItem);
      let posterUrl = `${recordItem?.posterpath}${
        recordItem?.posterfilelist?.split(";")[2]
      }`;
      let posterUrl2 = `${recordItem?.posterpath}${
        recordItem?.posterfilelist?.split(";")[0]
      }`;
      setPosterSrc(posterUrl);
      setVerticalPosterPath(posterUrl2);
      getUserSeriesNpvr(seriesHeadId);
    } else if (!!epgProgramId && userInfo) {
      getProgram(epgProgramId);
    }
  }, [
    epgProgramId,
    seriesHeadId,
    userInfo,
    userFrameConfig,
    myTvChannelProgram
  ]);

  useEffect(() => {
    if (programRef.current) {
      let obj = {
        epgProgramId: programRef.current.epgProgramId,
        seriesheadid: programRef.current.seriesheadid,
        channelcode: programRef.current.channelcode
      };
      pageChanged(
        isRecord ? "/npvrdetail" : "/programdetail",
        location.pathname,
        "",
        obj
      );
    }
  }, [programRef.current]);

  useEffect(() => {
    disableBodyScroll(document.body, { reserveScrollBarGap: true });
    return () => {
      enableBodyScroll(document.body);
      let obj = {
        epgProgramId: programRef.current?.epgProgramId,
        seriesheadid: programRef.current?.seriesheadid,
        channelcode: programRef.current?.channelcode
      };
      pageChanged(
        location.pathname,
        isRecord ? "/npvrdetail" : "/programdetail",
        "",
        obj
      );
    };
  }, []);

  useEffect(() => {
    if (directlyPlay) {
      if (seriesHeadId) {
        getUserSeriesNpvr(seriesHeadId);
      }
    }
  }, []);
  // useEffect(()=>{
  //   if(episodes != []){
  //     if (directlyPlay) {
  //       if (isRecord) {
  //         console.log("episodes",episodes[0]?.epgProgramId);
  //         //getProgram(episodes[0]?.epgProgramId,episodes[0]);
  //       }
  //     }
  //   }
  // },[episodes])
  console.log("programData", programData);

  const mainHorizontalPosterUrl = getProgramPosterUrl(programData?.posters);

  return (
    <Modal
      onClose={() => { if (!isAnyPopupOpened.current) closeModal(); }}
      label={translateText(programData?.title)}
      viewClass={`vod-modal program-detail-modal ${
        fromTvGuide ? "atlas-guide-modal" : ""
      }`}
      isHide={directlyPlay}
    >
      {recordError && <div role="alert">{recordError}</div>}
      <div
        ref={modalRef}
        className="vod-detail-container-new"
        style={{
          opacity: directlyPlay ? 0 : 1,
          width: "37.91vw", // <-- Always the same width
          maxWidth: "1800px", //
          minWidth: "480px",
          maxHeight: "90vh", // <-- Modal max height
          height: "auto"
        }}
      >
        <div
          className="vod-detail-box-new"
          // style={{
          //   height: showFullContent ? "auto" : "calc(100vh - 140px)"
          // }}
        >
          <div>
            <div ref={posterWrapperRef} className="poster-wrapper">
              <div className="img-wrapper">
                {canWatch ? (
                  <img
                    alt="vod detail poster"
                    src={mainHorizontalPosterUrl || defaultPoster}
                    onError={() => setPosterSrc(defaultPoster)}
                  />
                ) : (
                  <ChannelControl />
                )}
              </div>
              <button
                type="button"
                className="close"
                aria-label={localizationStrings.close || "Close"}
                onClick={() => {
                  isRecord ? closeModal(null, true) : closeModal();
                }}
              >
                <PopupCloseIcon />
              </button>
            </div>
            <div
              className={`content-area`}
              style={{
                // maxHeight: showFullContent ? "400px" : "none",
                overflowY: showFullContent ? "auto" : "visible"
              }}
            >
              {" "}
              {/* <-- Renamed from container-absolute */}
              <div className="container-1">
                <div className="title">{translateText(programData?.title)}</div>
                <div className="record-actions" style={{ display: "flex" }}>
                  <div className="button-wrapper">{renderButton()}</div>
                </div>
              </div>
              {watchError && (
                <p role="alert" className="program-watch-error">
                  {getBroadcastCopy().playError}
                </p>
              )}
              {isRecord && seriesHeadId && seriesHeadId !== "0" ? (
                <div className="record-items-wrapper">
                  {renderedEpisodesItems}
                </div>
              ) : (
                <div className="container-2">
                  <div className="row" style={{ display: "inline" }}>
                    <div className="genre">
                      {programData?.category?.split(";")?.map((item, index) => {
                        return (
                          <a
                            key={index}
                            className="link"
                            onClick={() =>
                              history.push(`/dashboard/search/${item}`)
                            }
                          >
                            {item}
                            {`${
                              programData?.category?.split(";").length - 1 ===
                              index
                                ? ""
                                : ", "
                            }`}
                          </a>
                        );
                      })}
                    </div>
                    <div className="ratings">
                      <div className="rating">
                        {programData?.rating?.age === "G" ? (
                          <RtukGeneralIcon />
                        ) : programData?.rating?.age === "7+" ? (
                          <RtukSevenAgeIcon />
                        ) : programData?.rating?.age === "13+" ? (
                          <RtukThirteenAgeIcon />
                        ) : programData?.rating?.age === "18+" ? (
                          <RtukAgeIcon />
                        ) : null}
                      </div>
                      {getParentalAdvisoryElements(program?.rating?.categories)}
                    </div>

                    <div className="date">
                      {isCurrentlyPlaying && (
                        <div className="currently-watched-indicator">
                          {fromTvGuide
                            ? getBroadcastCopy().liveBadge
                            : localizationStrings.currentlyBeingWatched}
                        </div>
                      )}
                      {programData?.startTime && programData?.endTime
                        ? `${moment(programData.startTime)
                            .locale("en")
                            .format("HH:mm")} - ${moment(programData.endTime)
                            .locale("en")
                            .format("HH:mm")}`
                        : prettyTimeFormatter(programData?.duration)}
                    </div>
                  </div>
                  <div className="row" style={{ display: "inline" }}>
                    <div className="synopsis-box">
                      {translateText(showFullContent || !isDescriptionLong
                        ? programData?.description
                        : programData?.description?.slice(
                            0,
                            DESCRIPTION_LIMIT
                          ) + "...")}
                    </div>
                  </div>
                  {!showFullContent && isDescriptionLong && (
                    <div className="see-more-row">
                      <a
                        className="see-more-link"
                        onClick={() => setShowFullContent(true)}
                      >
                        {localizationStrings.showMore}
                      </a>
                    </div>
                  )}
                  {showFullContent && isDescriptionLong && (
                    <div className="see-less-row">
                      <a
                        className="see-less-link"
                        onClick={() => setShowFullContent(false)}
                      >
                        {localizationStrings.showLess}
                      </a>
                    </div>
                  )}
                </div>
              )}
              {/* {showFullContent && hasCasts && (
                <div className="container-3">
                  <div className="card">
                    <div className="title">{localizationStrings.cast}</div>
                    <CastCarousel
                      casts={programData?.casts}
                      history={history}
                    />
                  </div>
                </div>
              )} */}
            </div>

            {/* <div className="gradient"></div> */}
          </div>
        </div>
      </div>
      {showPlayer ? (
        <Modal viewClass={`player-modal `}>
          <VideoPlayer
            key="program-player"
            options={playerOptions}
            src={playUrl}
            vod={programData}
            epgProgramId={epgProgramId}
            isRecord={isRecord}
            closeRecordModal={() => {
              setShowPlayer(false);
              if (directlyPlay) {
                closeModal(directlyPlay);
              }
            }}
            thumbnails={thumbnails}
            isTimeshiftEnable={true}
            fromVodGrid={fromVodGrid}
            fromTvGuide={fromTvGuide}
            onReturnLive={
              fromTvGuide
                ? () => {
                    setSelectedCutvProgram(null);
                    closeModal(true);
                  }
                : undefined
            }
          />
        </Modal>
      ) : null}

      {showNotification ? (
        <Notification
          text={localizationStrings.deleteRecordConfirmText}
          confirmText={localizationStrings.delete}
          notConfirmText={localizationStrings.cancel}
          onClickConfirm={() => {
            deleteRecord(true);
          }}
          onClickNotConfirm={() => setShowNotification(false)}
          dontUsePortal={isPlayer}
        />
      ) : null}
      {isRecordOptionsOpen &&
        ReactDOM.createPortal(
          <RecordOptionsPopup
            recordStatus={isAddRecordStatus ? "-2" : String(npvrStatus ?? "")}
            onClose={handleCloseRecordOptions}
            onRecordSeries={() => checkRecordLimit(true)}
            onRecordEpisode={() => checkRecordLimit()}
            onDeleteSeries={() => deleteRecord(true)}
            onDeleteEpisode={() => deleteRecord(false)}
          />,
          document.body
        )}
      {/* {showDeleteOptions ? (
        <Modal viewClass="record-option-modal">
          <div className="record-option-wrapper">
            <div className="close-row" style={{ marginTop: "2.4vw" }}>
              <div
                className="close"
                onClick={() => setShowDeleteOptions(false)}
              >
                <PopupCloseIcon />
              </div>
            </div>
            <div className="record-option-title">
              {localizationStrings.deleteRecordOption}
            </div>
            <label
              className="record-option yellow"
              onClick={() => {
                deleteRecord(true);
                setShowDeleteOptions(false);
              }}
            >
              {localizationStrings.deleteAllSerie}
            </label>
            <label
              className="record-option transparent"
              onClick={() => {
                deleteRecord(false);
                setShowDeleteOptions(false);
              }}
            >
              {localizationStrings.deleteRecordEpisode}
            </label>
          </div>
        </Modal>
      ) : null} */}
      {showLimitWarning ? (
        <Notification
          text={limitMessage}
          confirmText={localizationStrings.continue}
          notConfirmText={localizationStrings.cancel}
          onClickConfirm={() => {
            startRecord(isSerieProgram.current);

            setShowLimitWarning(false);
          }}
          onClickNotConfirm={() => {
            setShowLimitWarning(false);
          }}
          dontUsePortal={isPlayer}
        />
      ) : null}
      {showPayment ? (
        <PpvPayment
          program={programRef.current}
          ppvProduct={ppvProduct}
          closePpv={(val) => {
            setShowPayment(false);
            if (val) {
              getPpvAuth(programRef.current.epgProgramId);
            }
            // setIsPpvSuccess(val, productcode);
          }}
        />
      ) : null}
    </Modal>
  );
};

export default ProgramDetail;
